import { useNavigate, useLocation } from "react-router-dom";
import logo from "../img/swb-logo.png";

const SignupComplete = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const statusId = location.state?.statusId;

  if (!statusId) {
    navigate("/login", { replace: true });
    return null;
  }

  const isVerified = statusId === 1;

  return (
    <section className="w-screen h-screen py-16 bg-slate-50">
      <div className="main-bg">&nbsp;</div>
      <div className="flex items-center flex-col z-10 relative">
        <div className="flex">
          <img src={logo} alt="Logo" className="w-72" />
        </div>

        <div
          className="bg-white rounded-xl shadow-2xl py-10 mt-8 px-8 w-full flex flex-col items-center"
          style={{ maxWidth: 600 }}
        >
          {isVerified ? (
            <>
              <div className="text-green-500 mb-6">
                <svg
                  className="w-16 h-16 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>

              <h1 className="text-3xl text-[#41264B] font-bold text-center mb-4">
                You're all set!
              </h1>

              <p className="text-gray-600 text-center mb-6">
                We've verified your details and your account is ready to go.
              </p>

              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 w-full">
                <p className="text-green-800 text-center font-medium">
                  You can log in straight away.
                </p>
              </div>

              <button
                onClick={() => navigate("/login", { replace: true })}
                className="bg-[#41264B] text-white rounded-lg px-6 py-3 font-medium hover:opacity-90 transition"
              >
                Continue to Login
              </button>
            </>
          ) : (
            <>
              <div className="text-amber-500 mb-6">
                <svg
                  className="w-16 h-16 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01M4.93 19h14.14a1 1 0 00.87-1.5L12.87 4a1 1 0 00-1.74 0L4.06 17.5a1 1 0 00.87 1.5z"
                  ></path>
                </svg>
              </div>

              <h1 className="text-3xl text-[#41264B] font-bold text-center mb-4">
                Almost there
              </h1>

              <p className="text-gray-600 text-center mb-6">
                We couldn't instantly verify your details, so our team needs to
                run a few quick checks before your account is active.
              </p>

              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 w-full">
                <p className="text-amber-800 text-center font-medium">
                  We'll email you as soon as your account has been approved.
                  This can take up to 2-3 working days.
                </p>
              </div>

              <button
                onClick={() => navigate("/login", { replace: true })}
                className="bg-[#41264B] text-white rounded-lg px-6 py-3 font-medium hover:opacity-90 transition"
              >
                Back to Login
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default SignupComplete;
